import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Notification, Button } from '@deal/components';
import { usePathContext } from '../../context/PathContext.js';
import isPathOnTerminalNode from '../../helpers/isPathOnTerminalNode.js';
import usSubmitDryRunCommand from '../../commands/useSubmitDryRunCommand.js';
import styles from './styles.css.js';

var DryRunInfo = function DryRunInfo(_ref) {
  var dryRunInfoViewModel = _ref.dryRunInfoViewModel;

  var _a;

  var pathContext = usePathContext();

  var _useSubmitDryRunComma = usSubmitDryRunCommand(),
      _useSubmitDryRunComma2 = _slicedToArray(_useSubmitDryRunComma, 2),
      submitDryRun = _useSubmitDryRunComma2[0],
      loading = _useSubmitDryRunComma2[1].loading;
  /**
   * Since we can end up on a dry run view model but in a completed state, hide the next node button
   * since there is no next action to take
   */


  var onLastNode = pathContext.pathGraphFlow && isPathOnTerminalNode(pathContext.pathGraphFlow, (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id);
  return React.createElement("div", {
    className: styles.wrapper
  }, dryRunInfoViewModel.sections.map(function (section, idx) {
    return React.createElement(Notification, {
      type: "info",
      key: idx,
      hideIcon: true
    }, React.createElement("div", null, section.summaryText), React.createElement("ul", {
      className: styles.detailRows
    }, section.detailRows.map(function (detailRow) {
      return React.createElement("li", {
        key: detailRow.key,
        className: styles.item
      }, detailRow.key, ": ", detailRow.value, ' ');
    })));
  }), React.createElement("div", {
    className: styles.actions
  }, React.createElement("div", {
    className: styles.buttons
  }, !onLastNode && React.createElement(Button, {
    disabled: loading,
    type: "submit",
    size: "large",
    tabIndex: 1,
    onClick: function onClick() {
      return submitDryRun();
    }
  }, "Next Node"))));
};

export default DryRunInfo;
//# sourceMappingURL=index.js.map
